import useTranslation from "~/kernel/internationalization/useTranslation";
import ROUTES from "~/kernel/routing/ROUTES";
import { useRepresentationContext } from "~/kernel/auth/useRepresentationContext";
import { RepresentationType } from "~/kernel/auth/determineRepresentation";

export default function useLinks() {
  const representation = useRepresentationContext();
  const { t } = useTranslation();

  switch (representation.type) {
    case RepresentationType.Anonymous:
    default:
      return [
        {
          to: ROUTES.blogPosts.path(),
          children: t("nav.blog"),
        },
        {
          to: ROUTES.connectCompany.path({}),
          children: t("nav.connectCompany"),
        },
        {
          to: ROUTES.login.path(),
          children: t("nav.login"),
        },
      ];
    case RepresentationType.Company:
      return [
        {
          to: ROUTES.companyBookings.path({
            day: undefined,
            employeeId: undefined,
          }),
          children: t("nav.bookings"),
        },
        {
          to: ROUTES.presences.path({
            day: undefined,
            employeeId: undefined,
          }),
          children: t("nav.schedule"),
        },
        {
          to: ROUTES.journals.path(),
          children: t("nav.customers"),
        },
        {
          to: ROUTES.employees.path(),
          children: t("nav.employees"),
        },
        {
          to: ROUTES.services.path(),
          children: t("nav.services"),
        },
        {
          to: ROUTES.sendOuts.path(),
          children: t("nav.sendOuts"),
        },
        {
          to: ROUTES.logout.path({}),
          children: t("nav.logout"),
        },
      ];
    case RepresentationType.Admin:
      return [
        {
          to: ROUTES.admin.home.path(),
          children: t("nav.home"),
        },
        {
          to: ROUTES.logout.path({}),
          children: t("nav.logout"),
        },
      ];
    case RepresentationType.Customer:
      return [
        {
          to: ROUTES.customerHomeBookings.path(),
          children: t("nav.bookings"),
        },
        {
          to: ROUTES.customerHomeAnimals.path(),
          children: t("nav.animals"),
        },
        {
          to: ROUTES.logout.path({}),
          children: t("nav.logout"),
        },
      ];
  }
}
